import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "adm-select-wrapper" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 1,
  class: "adm-select-placeholder"
}
const _hoisted_4 = ["id", "disabled"]
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = {
  key: 0,
  class: "adm-select-trailing-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adm_icon = _resolveComponent("adm-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.hasLabel)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "adm-select-label",
            for: _ctx.identifier
          }, _toDisplayString(_ctx.label), 9, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.hasPlaceholder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("select", _mergeProps({
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
      }, _ctx.$attrs, {
        id: _ctx.identifier,
        disabled: _ctx.disabled,
        class: "adm-select-native"
      }), [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.value,
            value: option.value,
            disabled: option.disabled
          }, _toDisplayString(option.label), 9, _hoisted_5))
        }), 128))
      ], 16, _hoisted_4), [
        [_vModelSelect, _ctx.value]
      ]),
      _createVNode(_component_adm_icon, {
        class: "adm-select-arrow",
        icon: "arrow_drop_down",
        type: "round"
      })
    ]),
    (_ctx.error || _ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error || _ctx.description), 1))
      : _createCommentVNode("", true)
  ], 2))
}